var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSignatureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EmailSignatureIcon; Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    d: "M20 8L12 13L4 8V18H20V8Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "EmailSignatureIcon; Light Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    opacity: 0.5,
    d: "M20 6H4L12 10.99L20 6Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "EmailSignatureIcon; Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20ZM20 6L12 10.99L4 6H20ZM12 13L4 8V18H20V8L12 13Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSignatureIcon);
export default __webpack_public_path__ + "static/media/emailSignatureIcon.2e6d6eb11e8d807d4b6a43ff90da4567.svg";
export { ForwardRef as ReactComponent };